import { SVGProps } from 'react';

export default function Prepare7(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3359)">
        <path
          d="M17.1435 3.59364L12.1435 0.593643C11.4963 0.203959 10.7552 -0.00195313 9.99975 -0.00195312C9.24431 -0.00195313 8.50317 0.203959 7.856 0.593643L2.856 3.59364C2.24052 3.96558 1.73116 4.48969 1.37693 5.11553C1.02271 5.74137 0.835559 6.44785 0.833496 7.16698V12.8336C0.835559 13.5528 1.02271 14.2593 1.37693 14.8851C1.73116 15.5109 2.24052 16.035 2.856 16.407L7.856 19.407C8.5031 19.7968 9.24427 20.0029 9.99975 20.0029C10.7552 20.0029 11.4964 19.7968 12.1435 19.407L17.1435 16.407C17.7591 16.0351 18.2687 15.5111 18.623 14.8852C18.9774 14.2594 19.1647 13.5528 19.1668 12.8336V7.16698C19.1647 6.44777 18.9774 5.74123 18.623 5.11539C18.2687 4.48955 17.7591 3.96548 17.1435 3.59364ZM8.71433 2.02364C9.10244 1.78971 9.54701 1.66609 10.0002 1.66609C10.4533 1.66609 10.8979 1.78971 11.286 2.02364L16.286 5.02364C16.4226 5.10583 16.551 5.20099 16.6693 5.30781L10.0027 9.30781L3.336 5.30781C3.45419 5.2008 3.58258 5.10563 3.71933 5.02364L8.71433 2.02364ZM3.71433 14.9778C3.34483 14.7548 3.03901 14.4403 2.82635 14.0648C2.61368 13.6892 2.50135 13.2652 2.50016 12.8336V7.16698C2.50005 7.03436 2.51092 6.90196 2.53266 6.77114L9.16683 10.7503V18.1903C9.00926 18.1341 8.85768 18.0624 8.71433 17.9761L3.71433 14.9778ZM17.5002 12.8336C17.4988 13.2652 17.3864 13.6891 17.1738 14.0647C16.9611 14.4402 16.6554 14.7547 16.286 14.9778L11.286 17.9778C11.1427 18.0641 10.9911 18.1358 10.8335 18.192V10.7503L17.4677 6.77031C17.4895 6.90141 17.5003 7.03408 17.5002 7.16698V12.8336Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3359">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
